<template>
    <div v-if="showAppDown">
        <div class="panel" align="center">
            <h4 class="redColoredText">
                Anwendung nicht verfügbar
            </h4>
            <p>
                Die Anwendung steht aktuell leider nicht zur Verfügung. Bitte versuchen Sie es später erneut.
            </p>
        </div>
    </div>
    <div v-else-if="isInitializationDone" class="panel" id="lifeinsurance-app">
        <span id="app-top"></span>
        <form @submit.prevent="handleSubmit" v-if="!submitted">

        <div id="error_insurance_companies_not_loaded" v-if="error_insurance_companies_not_loaded">
            <div class="alert-box alert">
                <h3>Fehler</h3>
                <p>Leider ist ein Fehler aufgetreten und die Liste der Versicherungsgesellschaften konnte nicht geladen werden. Bitte versuchen Sie es erneut. Bei anhaltenden Problemen kontaktieren Sie uns unter <a href="mailto:info@ratis.de">info@ratis.de</a>.</p>
            </div>
        </div>

            <div class="row">
                <div class="small-12 columns">
                    <h5>Angaben zum Versicherungsnehmer:</h5>
                </div>
            </div>
            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label class="row collapse">
                        <div class="columns small-1">
                            <input type="radio" name="gender" :value="constants.LAWFORM_HERR" v-model="fields.mandator.lawform" required>
                        </div>
                        <div class="columns small-11">Herr</div>
                    </label>
                    <label class="row collapse">
                        <div class="columns small-1">
                            <input type="radio" name="gender" :value="constants.LAWFORM_FRAU" v-model="fields.mandator.lawform">
                        </div>
                        <div class="columns small-11">Frau</div>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label>
                        <p class="question">Ihr Vorname:</p>
                        <input type="text" name="firstname" v-model="fields.mandator.prename" required>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label>
                        <p class="question">Ihr Nachname:</p>
                        <input type="text" name="surname" v-model="fields.mandator.surname" required>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label>
                        <p class="question">Straße:</p>
                        <input type="text" name="street" v-model="fields.mandator.street" required>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label>
                        <p class="question">Hausnummer:</p>
                        <input
                            type="text"
                            name="housenumber"
                            v-model="fields.mandator.house_number"
                            required
                        >
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label>
                        <p class="question">PLZ:</p>
                        <input
                            type="text"
                            name="zip"
                            v-model="fields.mandator.zip"
                            required
                        >
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label>
                        <p class="question">Ort:</p>
                        <input type="text" name="city" v-model="fields.mandator.city" required>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label>
                        <p class="question">Ihre E-Mail-Adresse:</p>
                        <input
                            type="email"
                            name="email"
                            v-model="fields.mandator.mail"
                            required
                        >
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label>
                        <p class="question">Ihre Telefon-Nummer (für Rückfragen):</p>
                        <input
                            type="text"
                            name="phone"
                            v-model="fields.mandator.phone"
                            required
                        >
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <p class="question">Besteht eine Rechtsschutzversicherung?</p>
                    <label class="row collapse">
                        <div class="columns small-1">
                            <input type="radio" name="rsv" :value="true" v-model="fields.caseData.has_rsv" required>
                        </div>
                        <div class="columns small-11">Ja</div>
                    </label>
                    <label class="row collapse">
                        <div class="columns small-1">
                            <input type="radio" name="rsv" :value="false" v-model="fields.caseData.has_rsv">
                        </div>
                        <div class="columns small-11">Nein</div>
                    </label>

                    <p class="alert-box info" v-if="showRsvAlertBox">
                        Bitte bedenken Sie die Möglichkeit, noch vor Erklärung des Widerrufs eine Rechtsschutzversicherung für eine eventuelle spätere rechtliche Auseinandersetzung mit der Versicherung abzuschließen. Bei Fragen hierzu sprechen Sie uns einfach an!
                    </p>
                </div>
            </div>



            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label>
                        <p class="question">Name Kontoinhaber:</p>
                        <input type="text" name="name_accountowner" v-model="fields.caseData.name_accountowner" required>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <label>
                        <p class="question">IBAN:</p>
                        <input type="text" name="iban" v-model="fields.mandator.iban" required>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 columns">
                    <h5>Angaben zur Versicherung:</h5>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <p class="question">Name der Versicherung:</p>
                    <select name="insurance_company" v-model="fields.caseData.life_insurance_company_id">
                        <option v-for="insurance_company in insurance_companies" v-bind:value="insurance_company.id" v-bind:key="insurance_company.id">
                            {{ insurance_company.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <p class="question">Vertrags-Nummer:</p>
                    <input type="text" name="contract_number" v-model="fields.caseData.contract_number" required>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <p class="question">Datum des Vertragsschlusses:</p>
                    <input type="date" name="contract_date" v-model="fields.caseData.contract_date" required>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <p class="question">Ist die Versicherung fondsgebunden?</p>
                    <label class="row collapse">
                        <div class="columns small-1">
                            <input type="radio" name="contract_fund" :value="true" v-model="fields.caseData.is_fund_contract" required>
                        </div>
                        <div class="columns small-11">Ja</div>
                    </label>
                    <label class="row collapse">
                        <div class="columns small-1">
                            <input type="radio" name="contract_fund" :value="false" v-model="fields.caseData.is_fund_contract">
                        </div>
                        <div class="columns small-11">Nein</div>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-6 columns">
                    <p class="question">Wie ist der Vertragsstand?</p>
                    <label class="row collapse">
                        <div class="columns small-1">
                            <input type="radio" name="contract_status" :value="constants.CONTRACT_STATE_RUNNING" v-model="fields.caseData.contract_state" required>
                        </div>
                        <div class="columns small-11">Laufend</div>
                    </label>
                    <label class="row collapse">
                        <div class="columns small-1">
                            <input type="radio" name="contract_status" :value="constants.CONTRACT_STATE_FINISHED" v-model="fields.caseData.contract_state">
                        </div>
                        <div class="columns small-11">Beendet</div>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="small-12 medium-4 columns">
                    <button class="button success round expand" type="submit" :disabled="submitting">
                        <span v-if="submitting">Wird gesendet...
                            <img src="./assets/loader.svg">
                        </span>
                        <span v-else>Schreiben kostenlos erstellen</span>
                    </button>
                </div>
            </div>
        </form>

        <div id="page2" v-if="submitted && !error">
            <ConfirmationPage />
        </div>

        <div id="error" v-if="error">
            <div class="alert-box alert">
                <h3>Fehler</h3>
                <p>Leider ist ein Fehler aufgetreten und Ihre Schreiben konnte nicht erstellt werden. Bitte versuchen Sie es erneut. Bei anhaltenden Problemen kontaktieren Sie uns unter <a href="mailto:info@ratis.de">info@ratis.de</a>.</p>
                <p><strong>Fehlermeldung: {{ error_msg }}</strong></p>
            </div>
        </div>

    </div>
</template>


<script>
import ConfirmationPage from "./ConfirmationPage.vue";
import Config from './constants/Config';
import LifeInsurance from './api/lifeInsurance';
import Maintenance from './api/maintenance';

export default {
    data() {
        return {
            fields: {
                mandator: {
                    lawform: null,
                    prename: null,
                    surname: null,
                    street: null,
                    house_number: null,
                    zip: null,
                    city: null,
                    mail: null,
                    phone: null,
                    iban: null
                },
                caseData: {
                    name_accountowner: null,
                    contract_number: null,
                    contract_date: null,
                    life_insurance_company_id: null,
                    is_fund_contract: null,
                    has_rsv: null,
                    contract_state: null
                }
            },
            trackingUrl: Config.TRACKING_URL,
            submitted: false, // true when submitted
            submitting: false, // true while submitting,
            error: false, // true if error occured
            error_insurance_companies_not_loaded: false, // true if list of insurance companies couldn't be loaded
            error_msg: '',
            insurance_companies: [],
            constants: {
                LAWFORM_HERR: 1,
                LAWFORM_FRAU: 2,
                CONTRACT_STATE_RUNNING: 0,
                CONTRACT_STATE_FINISHED: 1
            },
            showAppDown: false,
            isInitializationDone: false
        };
    },
    async mounted() {
        await this.checkHealth();

        if (!this.showAppDown)
            await this.populateInsuranceCompanies();

        this.isInitializationDone = true;
    },

    components: {
        ConfirmationPage
    },
    computed: {
        showRsvAlertBox()
        {
            return this.fields.caseData.has_rsv === false;
        }
    },
    methods: {
        // populate select field with names of insurance companies with JSON list from API
        async populateInsuranceCompanies() {
            try
            {
                this.insurance_companies = await LifeInsurance.getLifeInsuranceCompanies();
            }
            catch (error)
            {
                this.error_insurance_companies_not_loaded = true;
                // Scroll to top of the app
                var top = document.getElementById("app-top");
                top.scrollIntoView({behavior: "smooth"});
            }
        },
        // post data to API when form gets submitted
        async handleSubmit() {
            this.submitting = true;

            try
            {
                let response = await LifeInsurance.create(this.fields);

                if(response.error)
                {
                    this.error = true;
                    this.error_msg = response.error_msg;
                    this.submitted = true;
                }
                else
                    this.submitted = true;
            }
            catch (error)
            {
                console.log(error);
                this.error = true;
                this.error_msg = error;
                this.submitted = true;
            }

            // Scroll to top of the app
            var top = document.getElementById("app-top");
            top.scrollIntoView({behavior: "smooth"});

            this.createTrackingIframe();
        },
        createTrackingIframe()
        {
          let iframe = document.createElement('iframe');
          iframe.setAttribute('id', 'trackingIframe');
          iframe.setAttribute('src', this.trackingUrl);
          iframe.style.display = "none";
          document.body.appendChild(iframe);
          let me = this;
          iframe.onload = () => me.removeTrackingIframe();
        },
        removeTrackingIframe()
        {
          let iframe = document.getElementById('trackingIframe');
          document.body.removeChild(iframe);
        },
        async checkHealth()
        {
            try
            {
                let response = await Maintenance.checkHealth();

                if (response.is_down)
                    this.showAppDown = true;
            }
            catch (error)
            {
                this.showAppDown = true;
            }
        }
    }
};
</script>


<style>
#lifeinsurance-app h5 {
    font-weight: bold;
    font-size: 1.3rem;
    color: #4d4d4d;
    margin: 1.5rem 0 1rem 0;
}

#lifeinsurance-app .question {
    margin: 1.25rem 0 0.5rem 0;
    font-weight: bold;
    color: #4d4d4d;
    font-size: 1rem;
}

#lifeinsurance-app input[type=date] {
    width: 100%;
     box-sizing: border-box;
}

#lifeinsurance-app input.short {
    width: 100%;
     max-width: 200px;
     box-sizing: border-box;
}

#lifeinsurance-app button[type=submit] {
    font-weight: bold;
}

/* Consistent space between radio options */
#lifeinsurance-app .small-11 {
    margin-bottom: 15px;
}



</style>
